import { CloseOutlined, EyeOutlined, FileExcelOutlined, FilePdfOutlined } from "@ant-design/icons";
import { Button, Modal, Typography } from "antd";

const { Title } = Typography;
const colors = {
    primary: '#242166',
    secondary: '#1890ff',
    success: '#52c41a',
    warning: '#faad14',
    danger: '#ff4d4f',
    lightBg: '#f8f9fc',
    cardBg: '#ffffff',
    textPrimary: '#262626',
    textSecondary: '#8c8c8c',
    border: '#e8e8f0'
};

const PreviewModal = ({ visible, onClose, url, title, downloadName, excelFunction }) => (
    <Modal
        open={visible}
        onCancel={onClose}
        footer={null}
        width="85vw"
        style={{ top: 20 }}
        closable={false}
        bodyStyle={{ padding: 0, height: '85vh' }}
        zIndex={2000}
    >
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            background: colors.lightBg
        }}>
            <div style={{
                padding: '20px 24px',
                background: colors.primary,
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center'
            }}>
                <Title level={4} style={{ margin: 0, color: '#fff' }}>
                    <EyeOutlined style={{ marginRight: '12px' }} />
                    {title}
                </Title>
                <Button
                    icon={<CloseOutlined />}
                    onClick={onClose}
                    style={{
                        background: colors.danger,
                        border: 'none',
                        color: '#fff',
                        height: '36px',
                        borderRadius: '8px'
                    }}
                >
                    Fermer
                </Button>
            </div>

            <div style={{
                flex: 1,
                padding: '16px',
                overflow: 'hidden'
            }}>
                <iframe
                    src={url}
                    style={{
                        width: '100%',
                        height: '100%',
                        border: 'none',
                        borderRadius: '8px',
                        boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
                    }}
                    title="Aperçu PDF"
                />
            </div>

            <div style={{
                padding: '20px 24px',
                background: '#fff',
                borderTop: `1px solid ${colors.border}`,
                display: 'flex',
                justifyContent: 'center',
                gap: '16px'
            }}>
                <Button
                    type="primary"
                    icon={<FilePdfOutlined />}
                    size="large"
                    href={url}
                    download={downloadName}
                    style={{
                        background: colors.secondary,
                        border: 'none',
                        height: '48px',
                        minWidth: '200px',
                        borderRadius: '8px',
                        fontWeight: '600',
                        fontSize: '15px'
                    }}
                >
                    Télécharger le PDF
                </Button>
                {excelFunction && (
                    <Button
                        type="primary"
                        icon={<FileExcelOutlined />}
                        size="large"
                        onClick={excelFunction}
                        style={{
                            background: colors.success,
                            border: 'none',
                            height: '48px',
                            minWidth: '200px',
                            borderRadius: '8px',
                            fontWeight: '600',
                            fontSize: '15px'
                        }}
                    >
                        Télécharger l'Excel
                    </Button>
                )}
            </div>
        </div>
    </Modal>
);

export default PreviewModal;